document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".morando-configurator");
  if (!root) return;

  const btnPersonalizza = document.getElementById("btn-personalizza");
  const buyWrapper = document.getElementById("buy-buttons-wrapper");

  // Se nel tema esiste un altro bottone duplicato con lo stesso id, lo elimino
  // (difesa extra: non dovrebbe servire se inserisci lo snippet una sola volta)
  document.querySelectorAll("#btn-personalizza").forEach((el, i) => {
    if (i > 0) el.remove();
  });

  const params = new URLSearchParams(window.location.search);
  const pdf = params.get("pdf");
  const img = params.get("img");
  const config = params.get("config");
  const fileUrl = params.get("file");

  // Helper: trova form prodotto
  function getProductForm() {
    // Dawn: form[action*="/cart/add"]
    return document.querySelector('form[action^="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function ensureHiddenInput(form, name, value) {
    if (!value) return;
    let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function showSummaryBox() {
    const infoContainer = document.querySelector(".product__info-container") || root.closest(".product") || document.body;

    const box = document.createElement("div");
    box.style.cssText = `
      margin: 1em 0;
      padding: 1em;
      border-top: 1px solid #808080;
      border-bottom: 1px solid #808080;
      font-family: sans-serif;
      font-size: 0.95em;
    `;

    let html = `<p style="margin:0 0 .5em; font-size: 18px; color:#008000;">
      ✅ ${fileUrl ? "File caricato con successo." : "Timbro personalizzato con successo."}
    </p>`;

    if (fileUrl) {
      html += `<p style="margin:.5em 0;">
        <a href="${decodeURIComponent(fileUrl)}" target="_blank" rel="noopener" style="color:#121212; text-decoration:underline;">
          Visualizza file caricato
        </a>
      </p>`;
    } else {
      if (config) {
        const lines = decodeURIComponent(config).split("\n").filter(Boolean);
        if (lines.length) {
          html += `<div style="margin:.5em 0;">`;
          lines.forEach((t, i) => {
            html += `<p style="margin:.25em 0;"><strong>Riga ${i + 1}:</strong> ${escapeHtml(t)}</p>`;
          });
          html += `</div>`;
        }
      }
      if (pdf) {
        html += `<p style="margin:.5em 0;">
          <a href="${decodeURIComponent(pdf)}" target="_blank" rel="noopener" style="color:#AB273C; text-decoration:underline;">
            Scarica PDF
          </a>
        </p>`;
      }
      if (img) {
        html += `<p style="margin:.5em 0; text-align:center;">
          <img src="${decodeURIComponent(img)}" alt="Anteprima timbro"
               style="max-width:100%; border:1px solid #ccc; border-radius:4px;" />
        </p>`;
      }
    }

    html += `<button id="reset-config" type="button"
      style="background:none;border:none;cursor:pointer;font-size:1.0em;color:#AB273C;margin-top:.5em;">
      🗑️ Rimuovi personalizzazione
    </button>`;

    box.innerHTML = html;

    // Inserisco dopo il titolo
    const titleEl = infoContainer.querySelector("#product-title, .product__title, h1");
    if (titleEl && titleEl.parentNode) titleEl.parentNode.insertBefore(box, titleEl.nextSibling);
    else infoContainer.prepend(box);

    const resetBtn = box.querySelector("#reset-config");
    resetBtn?.addEventListener("click", () => {
      // Rimuovo params dalla URL
      const clean = new URL(window.location.href);
      ["pdf", "img", "config", "file"].forEach(k => clean.searchParams.delete(k));
      window.location.href = clean.toString();
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    }[m]));
  }

  // Se torno dal configuratore con dati → creo line item properties e mostro buy buttons
  const hasData = !!(pdf || img || config || fileUrl);

  if (hasData) {
    const form = getProductForm();
    if (form) {
      ensureHiddenInput(form, 'properties[PDF]', pdf ? decodeURIComponent(pdf) : "");
      ensureHiddenInput(form, 'properties[Anteprima]', img ? decodeURIComponent(img) : "");
      ensureHiddenInput(form, 'properties[Testo]', config ? decodeURIComponent(config) : "");
      ensureHiddenInput(form, 'properties[File]', fileUrl ? decodeURIComponent(fileUrl) : "");
    }

    if (buyWrapper) buyWrapper.style.display = "block";
    if (btnPersonalizza) btnPersonalizza.style.display = "none";

    showSummaryBox();
    return;
  }

  // Altrimenti: siamo “prima” della personalizzazione → mostro solo Personalizza
  if (buyWrapper) buyWrapper.style.display = "none";
  if (btnPersonalizza) btnPersonalizza.style.display = "block";

  // Click: vai su morando.store passando handle, variante e misure (w/h o diametro)
  btnPersonalizza?.addEventListener("click", () => {
    const shopBase = root.dataset.shopBase;
    const productHandle = root.dataset.productHandle;
    const productUrl = root.dataset.productUrl;
    const morandoBase = root.dataset.morandoBase || "https://morando.store";

    const map = JSON.parse(root.dataset.variantMap || "{}");
    const form = getProductForm();
    let variantId = null;

    if (form) {
      const vInput = form.querySelector('input[name="id"]');
      if (vInput) variantId = vInput.value;
    }
    if (!variantId) {
      // fallback: prima variante in map
      variantId = Object.keys(map)[0] || "";
    }

    const m = map[String(variantId)] || {};
    const tipo = (m.tipo || "").toLowerCase();

    // routing pagine morando
    // tipo: "datario" | "rotondo" | "timbro" | "upload"
    let path = "/configuratori/configuratore-timbro.html";
    if (tipo.includes("datario")) path = "/configuratori/configuratore-datario.html";
    else if (tipo.includes("rotondo")) path = "/configuratori/configuratore-rotondo.html";
    else if (tipo.includes("upload")) path = "/configuratori/configuratore-upload.html";

    const url = new URL(morandoBase + path);
    url.searchParams.set("shop_base", shopBase);
    url.searchParams.set("product", productHandle);
    url.searchParams.set("variant", variantId);
    url.searchParams.set("return_url", new URL(productUrl, window.location.origin).toString());

    // misure
    if (m.larghezza) url.searchParams.set("larghezza", String(m.larghezza));
    if (m.altezza) url.searchParams.set("altezza", String(m.altezza));
    if (m.diametro) url.searchParams.set("diametro", String(m.diametro));

    window.location.href = url.toString();
  });
});
